<template>
    <div>
        <div class="modal fade modern-modal" tabindex="-1" id="ModalWorkflowConfiguracao" data-bs-focus="false">
            <div class="modal-dialog modal-dialog-centered modal-xl modal-modern">
                <div class="modal-content modal-modern-content border-0">
                    <button class="btn btn-md btn-icon btn-pill btn-white shadow position-absolute top-0 end-0 mt-n3 me-n3"
                            :disabled="saving || salvandoNome"
                            data-bs-dismiss="modal">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                             fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                        </svg>
                    </button>

                    <div class="modal-modern-header">
                        <div class="header-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M12,8A4,4 0 0,1 16,12A4,4 0 0,1 12,16A4,4 0 0,1 8,12A4,4 0 0,1 12,8M12,10A2,2 0 0,0 10,12A2,2 0 0,0 12,14A2,2 0 0,0 14,12A2,2 0 0,0 12,10M10,22C9.75,22 9.54,21.82 9.5,21.58L9.13,18.93C8.5,18.68 7.96,18.34 7.44,17.94L4.95,18.95C4.73,19.03 4.46,18.95 4.34,18.73L2.34,15.27C2.21,15.05 2.27,14.78 2.46,14.63L4.57,12.97L4.5,12L4.57,11L2.46,9.37C2.27,9.22 2.21,8.95 2.34,8.73L4.34,5.27C4.46,5.05 4.73,4.96 4.95,5.05L7.44,6.05C7.96,5.66 8.5,5.32 9.13,5.07L9.5,2.42C9.54,2.18 9.75,2 10,2H14C14.25,2 14.46,2.18 14.5,2.42L14.87,5.07C15.5,5.32 16.04,5.66 16.56,6.05L19.05,5.05C19.27,4.96 19.54,5.05 19.66,5.27L21.66,8.73C21.79,8.95 21.73,9.22 21.54,9.37L19.43,11L19.5,12L19.43,13L21.54,14.63C21.73,14.78 21.79,15.05 21.66,15.27L19.66,18.73C19.54,18.95 19.27,19.04 19.05,18.95L16.56,17.95C16.04,18.34 15.5,18.68 14.87,18.93L14.5,21.58C14.46,21.82 14.25,22 14,22H10M11.25,4L10.88,6.61C9.68,6.86 8.62,7.5 7.85,8.39L5.44,7.35L4.69,8.65L6.8,10.2C6.4,11.37 6.4,12.64 6.8,13.8L4.68,15.36L5.43,16.66L7.86,15.62C8.63,16.5 9.68,17.14 10.87,17.38L11.24,20H12.76L13.13,17.39C14.32,17.14 15.37,16.5 16.14,15.62L18.57,16.66L19.32,15.36L17.2,13.81C17.6,12.64 17.6,11.37 17.2,10.2L19.31,8.65L18.56,7.35L16.15,8.39C15.38,7.5 14.32,6.86 13.12,6.62L12.75,4H11.25Z" />
                            </svg>
                        </div>
                        <div class="header-text">
                            <h2>Configuração do Fluxo de Trabalho</h2>
                            <p>Personalize dependências, prazos e etapas do artefato selecionado no fluxo.</p>
                        </div>
                        <div class="header-status">
                            <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            <span v-if="rawConfig && (rawConfig.nmModelo || rawConfig.nmArtefato)" class="badge badge-artefato">
                                {{ rawConfig.nmModelo || rawConfig.nmArtefato }}
                            </span>
                        </div>
                    </div>

                    <div class="modal-modern-body">
                        <div v-if="!idProcessoWorkflowArtefato" class="empty-state">
                            <div class="empty-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none">
                                    <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M13.5 13.5L16.5 16.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M11 8C9.34315 8 8 9.34315 8 11C8 12.6569 9.34315 14 11 14C12.6569 14 14 12.6569 14 11C14 9.34315 12.6569 8 11 8Z" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </div>
                            <div>
                                <h5>ID de configuração ausente</h5>
                                <p>Selecione um artefato do processo para ajustar as configurações de fluxo.</p>
                            </div>
                        </div>

                        <div v-else class="section-stack">
                            <div class="section-card section-card--compact section-card--status"
                                 :class="form.flAtivo ? 'is-ativo' : 'is-inativo'">
                                <div class="section-header">
                                    <div class="section-header__info">
                                        <div class="section-icon status-icon">
                                            <svg v-if="form.flAtivo" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                                                <path d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z" />
                                            </svg>
                                            <svg v-else xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                                                <path d="M12 2C17.5 2 22 6.5 22 12S17.5 22 12 22 2 17.5 2 12 6.5 2 12 2M14.59 8L12 10.59L9.41 8L8 9.41L10.59 12L8 14.59L9.41 16L12 13.41L14.59 16L16 14.59L13.41 12L16 9.41L14.59 8Z" />
                                            </svg>
                                        </div>
                                        <div>
                                            <h3>Situação do artefato</h3>
                                            <p>Ao inativar, o artefato deixa de ser exigido. Nos processos, ele só permanece visível quando já possui um envio, para consulta do histórico.</p>
                                        </div>
                                    </div>
                                    <div class="section-header__actions">
                                        <span class="badge" :class="form.flAtivo ? 'badge-ativo' : 'badge-inativo'">
                                            {{ form.flAtivo ? 'Ativo' : 'Inativo' }}
                                        </span>
                                        <div class="form-check form-switch modern-switch m-0">
                                            <input class="form-check-input" type="checkbox" id="swAtivo" v-model="form.flAtivo">
                                            <label class="form-check-label fw-medium" for="swAtivo">
                                                Artefato ativo
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="section-card">
                                <div class="section-header">
                                    <div class="section-header__info">
                                        <div class="section-icon">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                                                <path d="M21 16V13C21 11.89 20.11 11 19 11H13V8H15V2H9V8H11V11H5C3.89 11 3 11.89 3 13V16H1V22H7V16H5V13H11V16H9V22H15V16H13V13H19V16H17V22H23V16H21M11 4H13V6H11V4M5 20H3V18H5V20M13 20H11V18H13V20M21 20H19V18H21V20Z" />
                                            </svg>
                                        </div>
                                        <div>
                                            <h3>Dependências</h3>
                                            <p>Indique se este artefato depende do envio prévio de outros modelos do processo.</p>
                                        </div>
                                    </div>
                                    <div class="section-header__actions section-header__actions--anexo">
                                        <p v-if="form.flDependencia" class="anexo-regra">
                                            O anexo entra no documento quando este artefato é gerado pela IA SollAI. O tipo de envio do arquivo anexado não importa.
                                        </p>
                                        <div class="section-header__switches">
                                            <div class="form-check form-switch modern-switch m-0">
                                                <input class="form-check-input" type="checkbox" id="swDependencia" v-model="form.flDependencia">
                                                <label class="form-check-label fw-medium" for="swDependencia">
                                                    Exige dependências
                                                </label>
                                            </div>
                                            <span v-if="form.flDependencia" class="badge badge-counter">
                                                {{ depCount }} selecionado(s)
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="form.flDependencia === true" class="section-content">
                                    <div class="dependency-toolbar">
                                        <p class="toolbar-text">
                                            Selecione os <strong>modelos</strong> que precisam ser concluídos antes deste artefato iniciar. Em cada um selecionado, indique se o documento finalizado entra como anexo e a ordem.
                                        </p>
                                        <div class="toolbar-actions">
                                            <div class="input-group modern-input toolbar-search">
                                                <span class="input-group-text">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none">
                                                        <path d="M21 21L16.65 16.65M18 10.5C18 14.6421 14.6421 18 10.5 18C6.35786 18 3 14.6421 3 10.5C3 6.35786 6.35786 3 10.5 3C14.6421 3 18 6.35786 18 10.5Z" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                                                    </svg>
                                                </span>
                                                <input type="text" class="form-control" v-model="dep.query" placeholder="Buscar modelo...">
                                            </div>
                                            <div class="form-check form-switch modern-switch">
                                                <input class="form-check-input" type="checkbox" id="swSelectAll"
                                                       :checked="filteredDepModelos.length > 0 && filteredDepModelos.every(m => dependenciaMarcada(m.idProcessoModeloArtefato))"
                                                       @change="toggleSelectAll($event.target.checked)">
                                                <label class="form-check-label" for="swSelectAll">Selecionar todos</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div v-if="dep.loading" class="state-message state-message--loading">
                                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        Carregando dependências existentes...
                                    </div>

                                    <div v-else-if="filteredDepModelos.length === 0" class="state-message state-message--empty">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 16 16" fill="currentColor">
                                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                                            <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533z" />
                                            <circle cx="8" cy="4.5" r="1" />
                                        </svg>
                                        Nenhum artefato ativo de ordem anterior encontrado.
                                    </div>

                                    <div v-else class="dependency-list">
                                        <div v-for="mdl in filteredDepModelos" :key="mdl.idProcessoModeloArtefato" class="dependency-item">
                                            <label class="dependency-item__info" :for="'dep-' + mdl.idProcessoModeloArtefato">
                                                <input class="form-check-input dep-check"
                                                       type="checkbox"
                                                       :id="'dep-' + mdl.idProcessoModeloArtefato"
                                                       :value="mdl.idProcessoModeloArtefato"
                                                       :checked="dependenciaMarcada(mdl.idProcessoModeloArtefato)"
                                                       :disabled="isSelfModel(mdl)"
                                                       @change="toggleDep(mdl.idProcessoModeloArtefato, $event.target.checked)" />
                                                <div>
                                                    <span class="dependency-title">{{ mdl.nmModelo }}</span>
                                                    <small class="dependency-description" v-if="mdl.dsDescricao">{{ mdl.dsDescricao }}</small>
                                                </div>
                                            </label>
                                            <div v-if="dependenciaMarcada(mdl.idProcessoModeloArtefato)" class="dependency-item__anexo">
                                                <div class="form-check form-switch modern-switch m-0">
                                                    <input class="form-check-input"
                                                           type="checkbox"
                                                           :id="'anexo-' + mdl.idProcessoModeloArtefato"
                                                           :checked="anexoDe(mdl.idProcessoModeloArtefato).flAnexo"
                                                           @change="toggleAnexo(mdl.idProcessoModeloArtefato, $event.target.checked)" />
                                                    <label class="form-check-label" :for="'anexo-' + mdl.idProcessoModeloArtefato">Anexo</label>
                                                </div>
                                                <div v-if="anexoDe(mdl.idProcessoModeloArtefato).flAnexo" class="anexo-ordem">
                                                    <label class="anexo-ordem__label" :for="'ordem-anexo-' + mdl.idProcessoModeloArtefato">Ordem</label>
                                                    <input :id="'ordem-anexo-' + mdl.idProcessoModeloArtefato"
                                                           type="number"
                                                           min="1"
                                                           step="1"
                                                           class="form-control anexo-ordem__input"
                                                           :value="anexoDe(mdl.idProcessoModeloArtefato).nrOrdemAnexo"
                                                           @input="definirOrdemAnexo(mdl.idProcessoModeloArtefato, $event.target.value)" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="section-card">
                                <div class="section-header">
                                    <div class="section-header__info">
                                        <div class="section-icon">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                                                <path d="M15,13H16.5V15.82L18.94,17.23L18.19,18.53L15,16.69V13M19,8H5V19H9.67C9.24,18.09 9,17.07 9,16A7,7 0 0,1 16,9C17.07,9 18.09,9.24 19,9.67V8M5,21C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3H6V1H8V3H16V1H18V3H19A2,2 0 0,1 21,5V11.1C22.24,12.36 23,14.09 23,16A7,7 0 0,1 16,23C14.09,23 12.36,22.24 11.1,21H5M16,11.15A4.85,4.85 0 0,0 11.15,16C11.15,18.68 13.32,20.85 16,20.85A4.85,4.85 0 0,0 20.85,16C20.85,13.32 18.68,11.15 16,11.15Z" />
                                            </svg>
                                        </div>
                                        <div>
                                            <h3>Prazos</h3>
                                            <p>Determine o tempo de execução previsto e como ele será contabilizado.</p>
                                        </div>
                                    </div>
                                    <div class="section-header__actions">
                                        <div class="form-check form-switch modern-switch m-0">
                                            <input class="form-check-input" type="checkbox" id="swPrazo" v-model="form.flPrazo">
                                            <label class="form-check-label fw-medium" for="swPrazo">Possui prazo</label>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="form.flPrazo === true" class="section-content">
                                    <div class="form-grid">
                                        <div class="form-group">
                                            <label class="form-label">Número de dias do prazo</label>
                                            <input type="number"
                                                   min="0"
                                                   class="form-control"
                                                   v-model.number="form.nrDiasPrazo"
                                                   placeholder="Ex.: 10">
                                        </div>
                                        <div class="form-group">
                                            <label class="form-label">Tipo de dias</label>
                                            <select class="form-select" v-model="form.tpDiasPrazo">
                                                <option value="CRD">Corridos</option>
                                                <option value="UTS">Úteis</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div v-if="form.flDependencia === true" class="form-group">
                                        <label class="form-label">O prazo passa a ser contado a partir de</label>
                                        <select class="form-select" v-model="form.tpInicioPrazo">
                                            <option value="INICIO">Início do processo</option>
                                            <option value="FINALIZACAO">Finalização dos artefatos dependentes</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div v-if="artefatoAdicionadoPeloCliente"
                                 class="alert alert-primary artefato-cliente-alert mb-3"
                                 role="note">
                                <div class="artefato-cliente-alert__info">
                                    <svg xmlns="http://www.w3.org/2000/svg"
                                         width="20"
                                         height="20"
                                         viewBox="0 0 24 24"
                                         fill="currentColor"
                                         class="flex-shrink-0 mt-1">
                                        <path d="M13 9H11V7H13V9M13 17H11V11H13V17M12 2C6.48 2 2 6.48 2 12S6.48 22 12 22 22 17.52 22 12 17.52 2 12 2Z" />
                                    </svg>
                                    <div>
                                        <strong>Artefato personalizado deste workflow</strong>
                                        <div class="small mt-1">
                                            Criado pelo cliente exclusivamente para este fluxo. Ele pode ter dependências, prazo e assinatura; as etapas de revisão e aprovação não se aplicam.
                                        </div>
                                    </div>
                                </div>
                                <button v-if="!editandoNome"
                                        type="button"
                                        class="btn btn-primary artefato-cliente-alert__acao"
                                        :disabled="saving || salvandoNome"
                                        @click="iniciarEdicaoNome">
                                    <svg xmlns="http://www.w3.org/2000/svg"
                                         width="18"
                                         height="18"
                                         viewBox="0 0 24 24"
                                         fill="currentColor">
                                        <path d="M20.71 7.04C21.1 6.65 21.1 6 20.71 5.63L18.37 3.29C18 2.9 17.35 2.9 16.96 3.29L15.13 5.12L18.88 8.87M3 17.25V21H6.75L17.81 9.93L14.06 6.18L3 17.25Z" />
                                    </svg>
                                    Editar nome
                                </button>
                                <div v-else class="artefato-cliente-alert__editor">
                                    <label for="nomeArtefatoWorkflow" class="form-label small fw-semibold mb-1">
                                        Nome do artefato
                                    </label>
                                    <div class="input-group">
                                        <input id="nomeArtefatoWorkflow"
                                               ref="campoNomeArtefato"
                                               v-model.trim="nomeArtefatoEditado"
                                               type="text"
                                               maxlength="100"
                                               class="form-control form-control-sm"
                                               :disabled="salvandoNome"
                                               @keyup.enter="salvarNomeArtefato"
                                               @keyup.esc="cancelarEdicaoNome" />
                                        <button type="button"
                                                class="btn btn-sm btn-primary"
                                                :disabled="!podeSalvarNomeArtefato"
                                                @click="salvarNomeArtefato">
                                            <span v-if="salvandoNome"
                                                  class="spinner-border spinner-border-sm me-1"
                                                  role="status"
                                                  aria-hidden="true"></span>
                                            Salvar
                                        </button>
                                        <button type="button"
                                                class="btn btn-sm btn-outline-secondary"
                                                :disabled="salvandoNome"
                                                @click="cancelarEdicaoNome">
                                            Cancelar
                                        </button>
                                    </div>
                                    <div class="form-text text-end">
                                        {{ nomeArtefatoEditado.length }}/100
                                    </div>
                                </div>
                            </div>

                            <div class="section-grid">
                                <div v-if="!artefatoAdicionadoPeloCliente"
                                     class="section-card section-card--compact">
                                    <div class="section-header">
                                        <div class="section-header__info">
                                            <div class="section-icon">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                                                    <path d="M20 17H22V15H20V17M20 7V13H22V7M6 16H11V18H6M6 12H14V14H6M4 2C2.89 2 2 2.89 2 4V20C2 21.11 2.89 22 4 22H16C17.11 22 18 21.11 18 20V8L12 2M4 4H11V9H16V20H4Z" />
                                                </svg>
                                            </div>
                                            <div>
                                                <h3>Revisão</h3>
                                                <p>Defina se o artefato precisa passar por revisão antes de avançar.</p>
                                            </div>
                                        </div>
                                        <div class="section-header__actions">
                                            <div class="form-check form-switch modern-switch m-0">
                                                <input class="form-check-input" type="checkbox" id="swRevisao" v-model="form.flRevisao">
                                                <label class="form-check-label fw-medium" for="swRevisao">Necessário revisão</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="form.flRevisao === true" class="section-content">
                                        <p class="runtime-envolvidos-note mb-0">
                                            Os revisores serão escolhidos no envio do artefato, pelo responsável na tela de continuidade do processo.
                                        </p>
                                    </div>
                                </div>

                                <div v-if="!artefatoAdicionadoPeloCliente"
                                     class="section-card section-card--compact">
                                    <div class="section-header">
                                        <div class="section-header__info">
                                            <div class="section-icon">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                                                    <path d="M23.5 17L18.5 22L15 18.5L16.5 17L18.5 19L22 15.5L23.5 17M6 2C4.89 2 4 2.9 4 4V20C4 21.11 4.89 22 6 22H13.81C13.45 21.38 13.2 20.7 13.08 20H6V4H13V9H18V13.08C18.33 13.03 18.67 13 19 13C19.34 13 19.67 13.03 20 13.08V8L14 2M8 12V14H16V12M8 16V18H13V16Z" />
                                                </svg>
                                            </div>
                                            <div>
                                                <h3>Aprovação</h3>
                                                <p>Defina se o artefato precisa ser aprovado antes de avançar.</p>
                                            </div>
                                        </div>
                                        <div class="section-header__actions">
                                            <div class="form-check form-switch modern-switch m-0">
                                                <input class="form-check-input" type="checkbox" id="swAprovacao" v-model="form.flAprovacao">
                                                <label class="form-check-label fw-medium" for="swAprovacao">Necessário aprovação</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="form.flAprovacao === true" class="section-content">
                                        <p class="runtime-envolvidos-note mb-0">
                                            Os aprovadores serão escolhidos no envio do artefato, pelo responsável na tela de continuidade do processo.
                                        </p>
                                    </div>
                                </div>

                                <div class="section-card section-card--compact">
                                    <div class="section-header">
                                        <div class="section-header__info">
                                            <div class="section-icon">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                                                    <path d="M19.7 12.9L14 18.6H11.7V16.3L17.4 10.6L19.7 12.9M23.1 12.1C23.1 12.4 22.8 12.7 22.5 13L20 15.5L19.1 14.6L21.7 12L21.1 11.4L20.4 12.1L18.1 9.8L20.3 7.7C20.5 7.5 20.9 7.5 21.2 7.7L22.6 9.1C22.8 9.3 22.8 9.7 22.6 10C22.4 10.2 22.2 10.4 22.2 10.6C22.2 10.8 22.4 11 22.6 11.2C22.9 11.5 23.2 11.8 23.1 12.1M3 20V4H10V9H15V10.5L17 8.5V8L11 2H3C1.9 2 1 2.9 1 4V20C1 21.1 1.9 22 3 22H15C16.1 22 17 21.1 17 20H3M11 17.1C10.8 17.1 10.6 17.2 10.5 17.2L10 15H8.5L6.4 16.7L7 14H5.5L4.5 19H6L8.9 16.4L9.5 18.7H10.5L11 18.6V17.1Z" />
                                                </svg>
                                            </div>
                                            <div>
                                                <h3>Assinatura</h3>
                                                <p>Indique se é necessário coletar assinatura digital do artefato.</p>
                                            </div>
                                        </div>
                                        <div class="section-header__actions">
                                            <div class="form-check form-switch modern-switch m-0">
                                                <input class="form-check-input" type="checkbox" id="swAssinatura" v-model="form.flAssinatura">
                                                <label class="form-check-label fw-medium" for="swAssinatura">Necessário assinatura</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="modal-modern-footer">
                        <button type="button"
                                class="btn btn-modern-primary w-100"
                                :disabled="saving || salvandoNome || !idProcessoWorkflowArtefato"
                                @click="save">
                            <span v-if="saving" class="spinner-border spinner-border-sm me-2"
                                  role="status" aria-hidden="true"></span>
                            Salvar configurações
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { urlApi, avisoErro, avisoToast } from '@/config/global'
    import axios from 'axios'

    export default {
        name: 'ModalWorkflowConfiguracao',
        props: {
            idProcessoWorkflowArtefato: Number,
            modelosArtefatos: { type: Array, default: () => [] },
            blockedModelIds: { type: Array, default: () => [] },
        },
        data() {
            return {
                loading: false,
                saving: false,
                editandoNome: false,
                salvandoNome: false,
                nomeArtefatoEditado: '',
                nomeArtefatoOriginal: '',
                rawConfig: null,
                form: {
                    idProcessoWorkflowArtefato: null,
                    idProcessoWorkflow: null,
                    idProcessoModeloArtefato: null,
                    flDependencia: false,
                    flPrazo: false,
                    flRevisao: false,
                    flAprovacao: false,
                    flAssinatura: false,
                    flAtivo: true,
                    nrDiasPrazo: null,
                    tpDiasPrazo: 'CRD',
                    tpInicioPrazo: 'INICIO',
                },

                showHandlerBound: null,
                hideHandlerBound: null,
                dep: {
                    loading: false,
                    checkedIds: [],
                    existingByModeloId: {},
                    anexoByModeloId: {},
                    query: '',
                },
                suppressReloadOnce: false,
            }
        },

        watch: {
            idProcessoWorkflowArtefato: {
                immediate: true,
                handler() {
                    this.maybeLoad();
                }
            },
            'form.flDependencia'(val) {
                if (val === true && this.form.idProcessoWorkflowArtefato) {
                    this.loadDeps();
                } else if (val === false) {
                    this.dep.checkedIds = [];
                    this.dep.existingByModeloId = {};
                    this.dep.anexoByModeloId = {};
                }
            },
        },

        computed: {
            modeloSelecionado() {
                const id = this.normalizeId(this.form.idProcessoModeloArtefato);
                return (this.modelosArtefatos || []).find(modelo =>
                    this.normalizeId(modelo.idProcessoModeloArtefato) === id
                ) || null;
            },

            // Modelo nativo vem com idCliente nulo; qualquer valor preenchido indica
            // inclusão pelo workflow, inclusive o cliente 0 (admin).
            artefatoAdicionadoPeloCliente() {
                return this.modeloSelecionado?.idCliente != null;
            },

            podeSalvarNomeArtefato() {
                const nome = this.nomeArtefatoEditado.trim();
                return this.editandoNome &&
                    !this.salvandoNome &&
                    nome.length > 0 &&
                    nome.length <= 100 &&
                    nome !== this.nomeArtefatoOriginal;
            },

            blockedIdsNormalized() {
                return (this.blockedModelIds || [])
                    .map(id => this.normalizeId(id))
                    .filter(id => id != null);
            },

            modelosFiltrados() {
                const selfModelId = this.normalizeId(this.form.idProcessoModeloArtefato);
                const ordemAtualRaw = this.modeloSelecionado?.nrOrdem;
                const ordemAtual = ordemAtualRaw == null ? NaN : Number(ordemAtualRaw);
                const blocked = this.blockedIdsNormalized;

                return (this.modelosArtefatos || []).filter(m => {
                    const mid = this.normalizeId(m.idProcessoModeloArtefato);
                    const ordemModelo = m.nrOrdem == null ? NaN : Number(m.nrOrdem);
                    if (mid == null) return false;
                    if (selfModelId != null && mid === selfModelId) return false;
                    if (blocked.includes(mid)) return false;
                    if (m.flAtivo === false) return false;
                    if (!Number.isFinite(ordemAtual) || !Number.isFinite(ordemModelo)) return false;
                    if (ordemModelo >= ordemAtual) return false;

                    return true;
                });
            },

            filteredDepModelos() {
                const q = (this.dep.query || '').toLowerCase().trim();
                if (!q) return this.modelosFiltrados;
                return this.modelosFiltrados.filter(m => {
                    const nome = String(m.nmModelo || '').toLowerCase();
                    const desc = String(m.dsDescricao || '').toLowerCase();
                    return nome.includes(q) || desc.includes(q);
                });
            },

            depCount() {
                return this.dep.checkedIds.length;
            },

        },

        methods: {
            resetState() {
                this.rawConfig = null;
                this.editandoNome = false;
                this.salvandoNome = false;
                this.nomeArtefatoEditado = '';
                this.nomeArtefatoOriginal = '';
                this.form = {
                    idProcessoWorkflowArtefato: null,
                    idProcessoWorkflow: null,
                    idProcessoModeloArtefato: null,
                    flDependencia: false,
                    flPrazo: false,
                    flRevisao: false,
                    flAprovacao: false,
                    flAssinatura: false,
                    flAtivo: true,
                    nrDiasPrazo: null,
                    tpDiasPrazo: 'CRD',
                    tpInicioPrazo: 'INICIO',
                };
                this.dep = {
                    loading: false,
                    checkedIds: [],
                    existingByModeloId: {},
                    anexoByModeloId: {},
                    query: '',
                };
            },

            normalizeId(id) {
                const n = Number(id);
                return Number.isNaN(n) ? null : n;
            },

            closeModal() {
                const el = document.getElementById('ModalWorkflowConfiguracao');
                if (!el) return;

                const bs = window.bootstrap || window.Bootstrap || null;

                if (bs && bs.Modal) {
                    const modalInstance = bs.Modal.getInstance(el) || new bs.Modal(el);
                    if (modalInstance) {
                        modalInstance.hide();
                    }
                } else if (window.$ && typeof window.$.fn.modal === 'function') {
                    window.$(el).modal('hide');
                }
            },

            maybeLoad() {
                if (!this.idProcessoWorkflowArtefato) return;
                this.getWorkflowConfiguracao();
            },

            attachShowListener() {
                const el = document.getElementById('ModalWorkflowConfiguracao');
                if (!el) return;

                if (this.showHandlerBound) {
                    el.removeEventListener('shown.bs.modal', this.showHandlerBound);
                }
                if (this.hideHandlerBound) {
                    el.removeEventListener('hidden.bs.modal', this.hideHandlerBound);
                }

                this.showHandlerBound = () => {
                    if (this.suppressReloadOnce) {
                        this.suppressReloadOnce = false;
                        return;
                    }
                    this.maybeLoad();
                };

                this.hideHandlerBound = () => {
                    this.resetState();
                };

                el.addEventListener('shown.bs.modal', this.showHandlerBound);
                el.addEventListener('hidden.bs.modal', this.hideHandlerBound);
            },

            getWorkflowConfiguracao() {
                const id = this.idProcessoWorkflowArtefato;
                if (!id) return;

                this.loading = true;
                axios.get(`${urlApi}/ProcessoWorkflow/GetWorkflowArtefato/${id}`)
                    .then(res => {
                        if (res.data && res.data.success) {
                            const cfg = res.data.data.processoWorkflowArtefato || {};
                            this.rawConfig = cfg;

                            this.form.idProcessoWorkflowArtefato = cfg.idProcessoWorkflowArtefato || id;
                            this.form.idProcessoWorkflow = cfg.idProcessoWorkflow || null;
                            this.form.idProcessoModeloArtefato = cfg.idProcessoModeloArtefato || null;
                            this.nomeArtefatoOriginal = this.modeloSelecionado?.nmModelo || '';
                            this.nomeArtefatoEditado = this.nomeArtefatoOriginal;
                            this.form.flAprovacao = typeof cfg.flAprovacao === 'boolean' ? cfg.flAprovacao : false;
                            this.form.flDependencia = typeof cfg.flDependencia === 'boolean' ? cfg.flDependencia : false;
                            this.form.flPrazo = typeof cfg.flPrazo === 'boolean' ? cfg.flPrazo : false;
                            this.form.flRevisao = typeof cfg.flRevisao === 'boolean' ? cfg.flRevisao : false;
                            this.form.flAssinatura = typeof cfg.flAssinatura === 'boolean' ? cfg.flAssinatura : false;
                            this.form.flAtivo = cfg.flAtivo !== false;
                            if (this.artefatoAdicionadoPeloCliente) {
                                this.form.flRevisao = false;
                                this.form.flAprovacao = false;
                            }

                            this.form.nrDiasPrazo = (this.form.flPrazo)
                                ? (typeof cfg.nrDiasPrazo === 'number' ? cfg.nrDiasPrazo : (cfg.nrDiasPrazo ? parseInt(cfg.nrDiasPrazo) : null))
                                : null;
                            this.form.tpDiasPrazo = cfg.tpDiasPrazo || 'CRD';
                            this.form.tpInicioPrazo = cfg.tpInicioPrazo || 'INICIO';
                        } else {
                            avisoErro(res.data?.msg || 'Erro ao carregar configurações.');
                        }
                    })
                    .catch(err => {
                        if (err.response && err.response.data) {
                            avisoErro(err.response.data);
                            avisoToast('Erro ao carregar configurações!', 'warning');
                        } else {
                            avisoErro(err.message || 'Erro desconhecido');
                        }
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },

            iniciarEdicaoNome() {
                if (!this.artefatoAdicionadoPeloCliente || this.salvandoNome) return;
                this.nomeArtefatoOriginal = this.modeloSelecionado?.nmModelo || '';
                this.nomeArtefatoEditado = this.nomeArtefatoOriginal;
                this.editandoNome = true;
                this.$nextTick(() => {
                    this.$refs.campoNomeArtefato?.focus();
                    this.$refs.campoNomeArtefato?.select();
                });
            },

            cancelarEdicaoNome() {
                if (this.salvandoNome) return;
                this.nomeArtefatoEditado = this.nomeArtefatoOriginal;
                this.editandoNome = false;
            },

            async salvarNomeArtefato() {
                if (!this.podeSalvarNomeArtefato) return;

                this.salvandoNome = true;
                try {
                    const nome = this.nomeArtefatoEditado.trim();
                    const resposta = await axios.post(
                        `${urlApi}/ProcessoWorkflow/PostRenomearArtefato`,
                        {
                            idProcessoWorkflowArtefato:
                                this.form.idProcessoWorkflowArtefato,
                            nmModelo: nome
                        },
                        { showLoading: false }
                    );

                    if (!resposta.data?.success)
                        throw new Error(resposta.data?.msg || 'Não foi possível renomear o artefato.');

                    this.nomeArtefatoOriginal = nome;
                    this.nomeArtefatoEditado = nome;
                    this.editandoNome = false;
                    this.$emit('renamed', resposta.data.data);
                    avisoToast('Nome do artefato atualizado.', 'success');
                } catch (e) {
                    const api = e?.response?.data;
                    const msg =
                        (Array.isArray(api?.errors) && api.errors.length ? api.errors[0] : null) ||
                        api?.msg ||
                        e?.message ||
                        'Não foi possível renomear o artefato.';
                    avisoErro(msg);
                } finally {
                    this.salvandoNome = false;
                }
            },

            async save() {
                const ok = await this.validateNoCyclesBeforeSave();
                if (!ok) return;
                if (!this.validarAnexos()) return;
                if (!this.form.idProcessoWorkflowArtefato) return;

                if (this.form.flPrazo === true) {
                    if (typeof this.form.nrDiasPrazo !== 'number' || isNaN(this.form.nrDiasPrazo) || this.form.nrDiasPrazo < 0) {
                        return avisoErro('Informe um número de dias válido.');
                    }
                    if (!this.form.tpDiasPrazo || (this.form.tpDiasPrazo !== 'CRD' && this.form.tpDiasPrazo !== 'UTS')) {
                        return avisoErro('Selecione o tipo de dias (CRD/UTS).');
                    }
                }

                const body = {
                    DadosProcessoWorkflowArtefato: {
                        idProcessoWorkflowArtefato: this.form.idProcessoWorkflowArtefato,
                        idProcessoWorkflow: this.form.idProcessoWorkflow,
                        idProcessoModeloArtefato: this.form.idProcessoModeloArtefato,
                        flDependencia: this.form.flDependencia,
                        flPrazo: this.form.flPrazo,
                        flRevisao: this.artefatoAdicionadoPeloCliente ? false : this.form.flRevisao,
                        flAprovacao: this.artefatoAdicionadoPeloCliente ? false : this.form.flAprovacao,
                        flAssinatura: this.form.flAssinatura,
                        flAtivo: this.form.flAtivo,
                        nrDiasPrazo: this.form.flPrazo ? this.form.nrDiasPrazo : null,
                        tpDiasPrazo: this.form.flPrazo ? this.form.tpDiasPrazo : null,
                        tpInicioPrazo: this.form.flPrazo ? (this.form.flDependencia ? this.form.tpInicioPrazo : 'INICIO') : null,
                    },
                };


                this.saving = true;
                try {
                    if (this.form.flDependencia === false) {
                        await this.deleteAllDepsForCurrent();
                    }

                    await axios.post(`${urlApi}/ProcessoWorkflow/PostWorkflowArtefato`, body, { showLoading: false });
                    if (this.form.flDependencia === true) {
                        await this.reconcileDeps();
                    }

                    this.$emit('saved');
                    avisoToast('Configuração salva.', 'success');
                    this.closeModal();
                } catch (e) {
                    const api = e?.response?.data;
                    const msg =
                        (Array.isArray(api?.errors) && api.errors.length ? api.errors[0] : null) ||
                        api?.msg ||
                        e?.message ||
                        'Falha ao salvar configuração.';

                    avisoErro(msg);
                } finally {
                    this.saving = false;
                }
            },

            async loadDeps() {
                this.dep.loading = true;
                this.dep.checkedIds = [];
                this.dep.existingByModeloId = {};
                this.dep.anexoByModeloId = {};
                try {
                    const res = await axios.get(`${urlApi}/ProcessoWorkflow/GetWorkflowDependencia`, {
                        params: { idProcessoWorkflowArtefato: this.form.idProcessoWorkflowArtefato }
                    });
                    const rows = res?.data?.data?.rows || [];
                    const idsPermitidos = new Set(
                        this.modelosFiltrados.map(m => this.normalizeId(m.idProcessoModeloArtefato))
                    );
                    rows.forEach(r => {
                        const d = r?.processoWorkflowDependencia || {};
                        const modeloDepId = this.normalizeId(d.idProcessoModeloArtefatoDependencia);
                        const idDep = d.idProcessoWorkflowDependencia;
                        if (modeloDepId && idsPermitidos.has(modeloDepId)) {
                            if (!this.dep.checkedIds.includes(modeloDepId)) this.dep.checkedIds.push(modeloDepId);
                            const ordem = d.nrOrdemAnexo == null || d.nrOrdemAnexo === '' ? null : Number(d.nrOrdemAnexo);
                            this.$set(this.dep.anexoByModeloId, modeloDepId, {
                                flAnexo: d.flAnexo === true,
                                nrOrdemAnexo: Number.isFinite(ordem) ? ordem : null,
                            });
                        }
                        if (modeloDepId && idDep) this.dep.existingByModeloId[modeloDepId] = idDep;
                    });
                } catch (e) {
                    avisoErro('Não foi possível carregar dependências.');
                } finally {
                    this.dep.loading = false;
                }
            },

            async fetchDepsExistingMapOnly() {
                try {
                    const res = await axios.get(`${urlApi}/ProcessoWorkflow/GetWorkflowDependencia`, {
                        params: { idProcessoWorkflowArtefato: this.form.idProcessoWorkflowArtefato }
                    });
                    const rows = res?.data?.data?.rows || [];
                    const map = {};
                    rows.forEach(r => {
                        const d = r?.processoWorkflowDependencia || {};
                        if (d.idProcessoModeloArtefatoDependencia && d.idProcessoWorkflowDependencia) {
                            map[d.idProcessoModeloArtefatoDependencia] = d.idProcessoWorkflowDependencia;
                        }
                    });
                    this.dep.existingByModeloId = map;
                } catch (e) {
                    // silenc
                }
            },

            async reconcileDeps() { 
                await this.fetchDepsExistingMapOnly();

                const currentMap = this.dep.existingByModeloId || {};
                const currentIds = Object.keys(currentMap).map(n => Number(n));
                const nextIds = this.dep.checkedIds.slice();

                const toCreate = nextIds.filter(id => !(id in currentMap));
                const toDelete = currentIds.filter(id => !nextIds.includes(id));
                const toUpdate = nextIds.filter(id => id in currentMap);

                for (const modeloId of toDelete) {
                    const idDep = currentMap[modeloId];
                    if (!idDep) continue;
                    try {
                        await axios.post(`${urlApi}/ProcessoWorkflow/DeleteWorkflowDependencias`, {
                            idProcessoWorkflowDependencia: idDep
                        }, { showLoading: false });
                    } catch (e) {
                        console.warn('Falha ao deletar dependência', idDep, e);
                    }
                }

                for (const depModeloId of toCreate) {
                    try {
                        await axios.post(`${urlApi}/ProcessoWorkflow/PostWorkflowDependencia`, this.corpoDependencia(depModeloId, 0), { showLoading: false });
                    } catch (e) {
                        console.warn('Falha ao criar dependência para modelo', depModeloId, e);
                    }
                }

                for (const depModeloId of toUpdate) {
                    const idDep = currentMap[depModeloId];
                    if (!idDep) continue;
                    try {
                        await axios.post(`${urlApi}/ProcessoWorkflow/PostWorkflowDependencia`, this.corpoDependencia(depModeloId, idDep), { showLoading: false });
                    } catch (e) {
                        console.warn('Falha ao atualizar dependência para modelo', depModeloId, e);
                    }
                }
            },

            async toggleDep(modeloId, checked) {
                const depId = this.normalizeId(modeloId);
                const currentId = this.normalizeId(this.form.idProcessoModeloArtefato);

                if (!depId) return;

                if (currentId && depId === currentId) {
                    avisoErro('Um artefato não pode depender de si mesmo.');
                    return;
                }

                const blocked = this.blockedIdsNormalized;
                if (blocked.includes(depId)) {
                    const nomeDep = this.getModeloNomeById(depId) || 'modelo selecionado';
                    avisoErro(`Dependência proibida: "${nomeDep}" já depende (direta ou indiretamente) deste artefato.`);
                    return;
                }

                if (checked) {
                    if (!this.dep.checkedIds.some(id => this.normalizeId(id) === depId)) {
                        this.dep.checkedIds.push(depId);
                    }
                } else {
                    this.dep.checkedIds = this.dep.checkedIds.filter(
                        id => this.normalizeId(id) !== depId
                    );
                    this.$delete(this.dep.anexoByModeloId, depId);
                }
            },

            anexoDe(modeloId) {
                const id = this.normalizeId(modeloId);
                return this.dep.anexoByModeloId[id] || { flAnexo: false, nrOrdemAnexo: null };
            },

            dependenciaMarcada(modeloId) {
                const id = this.normalizeId(modeloId);
                return this.dep.checkedIds.some(item => this.normalizeId(item) === id);
            },

            proximaOrdemAnexo() {
                const usadas = new Set();
                this.dep.checkedIds.forEach(raw => {
                    const anexo = this.anexoDe(raw);
                    if (anexo.flAnexo && Number.isInteger(anexo.nrOrdemAnexo) && anexo.nrOrdemAnexo >= 1) {
                        usadas.add(anexo.nrOrdemAnexo);
                    }
                });
                let ordem = 1;
                while (usadas.has(ordem)) ordem += 1;
                return ordem;
            },

            toggleAnexo(modeloId, ligado) {
                const id = this.normalizeId(modeloId);
                if (!id || !this.dependenciaMarcada(id)) return;
                if (ligado) {
                    this.$set(this.dep.anexoByModeloId, id, {
                        flAnexo: true,
                        nrOrdemAnexo: this.proximaOrdemAnexo(),
                    });
                    return;
                }
                this.$set(this.dep.anexoByModeloId, id, { flAnexo: false, nrOrdemAnexo: null });
            },

            definirOrdemAnexo(modeloId, valor) {
                const id = this.normalizeId(modeloId);
                if (!id) return;
                const texto = String(valor ?? '').trim();
                if (texto === '') {
                    this.$set(this.dep.anexoByModeloId, id, { flAnexo: true, nrOrdemAnexo: null });
                    return;
                }
                const numero = Number(texto);
                this.$set(this.dep.anexoByModeloId, id, {
                    flAnexo: true,
                    nrOrdemAnexo: Number.isFinite(numero) ? numero : null,
                });
            },

            validarAnexos() {
                if (this.form.flDependencia !== true) return true;
                const ordens = new Map();
                for (const raw of this.dep.checkedIds) {
                    const id = this.normalizeId(raw);
                    const anexo = this.anexoDe(id);
                    if (!anexo.flAnexo) continue;
                    const ordem = anexo.nrOrdemAnexo;
                    if (!Number.isInteger(ordem) || ordem < 1) {
                        const nome = this.getModeloNomeById(id) || 'dependência selecionada';
                        avisoErro(`Informe a ordem do anexo de "${nome}" com um número inteiro a partir de 1.`);
                        return false;
                    }
                    if (ordens.has(ordem)) {
                        avisoErro(`A ordem ${ordem} está repetida entre os anexos. Informe uma ordem diferente para cada um.`);
                        return false;
                    }
                    ordens.set(ordem, id);
                }
                return true;
            },

            corpoDependencia(depModeloId, idProcessoWorkflowDependencia) {
                const anexo = this.anexoDe(depModeloId);
                const flAnexo = anexo.flAnexo === true;
                return {
                    DadosProcessoWorkflowDependencia: {
                        idProcessoWorkflowDependencia,
                        idProcessoWorkflowArtefato: this.form.idProcessoWorkflowArtefato,
                        idProcessoModeloArtefato: this.form.idProcessoModeloArtefato,
                        idProcessoModeloArtefatoDependencia: depModeloId,
                        flAnexo,
                        nrOrdemAnexo: flAnexo ? anexo.nrOrdemAnexo : null,
                    }
                };
            },

            async validateNoCyclesBeforeSave() {
                const currentId = this.normalizeId(this.form.idProcessoModeloArtefato);
                const blocked = this.blockedIdsNormalized;
                const permitidos = new Set(
                    this.modelosFiltrados.map(m => this.normalizeId(m.idProcessoModeloArtefato))
                );

                if (!this.dep.checkedIds.length) {
                    return true;
                }

                for (const raw of this.dep.checkedIds) {
                    const depId = this.normalizeId(raw);
                    if (!depId) continue;

                    if (currentId && depId === currentId) {
                        avisoErro('Não é possível salvar: há uma dependência do artefato em si mesmo.');
                        return false;
                    }

                    if (!permitidos.has(depId)) {
                        const nomeDep = this.getModeloNomeById(depId) || `ID ${depId}`;
                        avisoErro(`Não é possível salvar: "${nomeDep}" não é um artefato ativo de ordem anterior.`);
                        return false;
                    }

                    if (blocked.includes(depId)) {
                        const nomeDep = this.getModeloNomeById(depId) || `ID ${depId}`;
                        avisoErro(`Não é possível salvar: a dependência com "${nomeDep}" criaria um ciclo no fluxo.`);
                        return false;
                    }
                }

                return true;
            },

            isSelfModel(mdl) {
                const selfId = this.normalizeId(this.form.idProcessoModeloArtefato);
                const mdlId = this.normalizeId(mdl.idProcessoModeloArtefato);
                return selfId != null && mdlId != null && selfId === mdlId;
            },

            getModeloNomeById(id) {
                const nid = this.normalizeId(id);
                const mdl = (this.modelosArtefatos || []).find(
                    m => this.normalizeId(m.idProcessoModeloArtefato) === nid
                );
                return mdl ? mdl.nmModelo : null;
            },

            toggleSelectAll(checked) {
                const idsOnScreen = this.filteredDepModelos.map(m => m.idProcessoModeloArtefato);

                if (checked) {
                    idsOnScreen.forEach(id => {
                        const depId = this.normalizeId(id);
                        if (!depId) return;
                        this.toggleDep(depId, true);
                    });
                } else {
                    const idsScreenNorm = idsOnScreen.map(id => this.normalizeId(id));
                    this.dep.checkedIds = this.dep.checkedIds.filter(
                        id => !idsScreenNorm.includes(this.normalizeId(id))
                    );
                    idsScreenNorm.forEach(id => {
                        if (id) this.$delete(this.dep.anexoByModeloId, id);
                    });
                }
            },

            async deleteAllDepsForCurrent() {
                if (!this.form.idProcessoWorkflowArtefato) return;

                let rows = [];
                try {
                    const res = await axios.get(`${urlApi}/ProcessoWorkflow/GetWorkflowDependencia`, {
                        params: { idProcessoWorkflowArtefato: this.form.idProcessoWorkflowArtefato }
                    });
                    rows = res?.data?.data?.rows || [];
                } catch (e) {
                    avisoErro('Não foi possível verificar dependências existentes.');
                    return;
                }

                if (!rows.length) {
                    this.dep.checkedIds = [];
                    this.dep.existingByModeloId = {};
                    this.dep.anexoByModeloId = {};
                    return;
                }

                for (const r of rows) {
                    const id = r?.processoWorkflowDependencia?.idProcessoWorkflowDependencia;
                    if (!id) continue;
                    try {
                        await axios.post(`${urlApi}/ProcessoWorkflow/DeleteWorkflowDependencias`, {
                            idProcessoWorkflowDependencia: id
                        }, { showLoading: false });
                    } catch (e) {
                        console.warn('Falha ao deletar dependência', id, e);
                    }
                }

                this.dep.checkedIds = [];
                this.dep.existingByModeloId = {};
                this.dep.anexoByModeloId = {};
            },

        },

        mounted() {
            this.maybeLoad();
            this.$nextTick(() => this.attachShowListener());
        },

        beforeUnmount() {
            const el = document.getElementById('ModalWorkflowConfiguracao');
            if (el && this.showHandlerBound) {
                el.removeEventListener('shown.bs.modal', this.showHandlerBound);
            }
        }
    }
</script>

<style lang="scss" scoped>
    :deep(.modern-modal) {
        .modal-modern-content {
            border-radius: 20px;
            background: linear-gradient(135deg, #fff 0%, #f8fafc 100%);
            box-shadow: 0 22px 60px rgba(15, 23, 42, 0.16);
            position: relative;
        }

        .modal-modern-header {
            display: flex;
            align-items: flex-start;
            gap: 18px;
            padding: 32px 32px 20px;
            position: relative;

            &::after {
                content: '';
                position: absolute;
                bottom: -1px;
                left: 32px;
                right: 32px;
                height: 1px;
                background: linear-gradient(90deg, transparent, rgba(148, 163, 184, 0.35), transparent);
            }

            .header-icon {
                width: 64px;
                height: 64px;
                border-radius: 20px;
                display: flex;
                align-items: center;
                justify-content: center;
                background: linear-gradient(135deg, rgba(59, 130, 246, 0.18) 0%, rgba(56, 189, 248, 0.18) 100%);
                color: #2563eb;
                flex-shrink: 0;
            }

            .header-text {
                flex: 1;

                h2 {
                    margin: 0;
                    font-size: 24px;
                    font-weight: 700;
                    color: #0f172a;
                }

                p {
                    margin: 8px 0 0;
                    color: #475569;
                    font-size: 14px;
                    line-height: 1.6;
                    max-width: 520px;
                }
            }

            .header-status {
                display: flex;
                align-items: center;
                gap: 12px;

                .badge-artefato {
                    background: linear-gradient(135deg, rgba(79, 70, 229, 0.12) 0%, rgba(14, 165, 233, 0.12) 100%);
                    color: #4338ca;
                    font-weight: 600;
                    padding: 6px 14px;
                    border-radius: 999px;
                    border: 1px solid rgba(99, 102, 241, 0.25);
                    text-transform: uppercase;
                    letter-spacing: 0.4px;
                    font-size: 11px;
                }
            }
        }

        .modal-modern-body {
            padding: 28px 32px 24px;
            display: flex;
            flex-direction: column;
            gap: 24px;
        }

        .modal-modern-footer {
            padding: 0 32px 32px;
        }

        .section-stack {
            display: flex;
            flex-direction: column;
            gap: 22px;
        }

        .artefato-cliente-alert {
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
            gap: 16px;
            padding: 16px 18px;

            &__info {
                display: flex;
                align-items: flex-start;
                gap: 10px;
                flex: 1;
                min-width: 0;
            }

            &__editor {
                width: min(100%, 540px);
                flex-shrink: 0;
            }

            &__acao {
                display: inline-flex;
                align-items: center;
                justify-content: center;
                gap: 8px;
                flex-shrink: 0;
                align-self: center;
                padding: 10px 18px;
                font-weight: 600;
                white-space: nowrap;
                border: none;
                border-radius: 12px;
                background: linear-gradient(135deg, #2563eb 0%, #0ea5e9 100%);
                box-shadow: 0 10px 22px rgba(37, 99, 235, 0.32);
                transition: transform 0.2s ease, box-shadow 0.2s ease;

                &:hover:not(:disabled),
                &:focus-visible:not(:disabled) {
                    transform: translateY(-1px);
                    box-shadow: 0 14px 28px rgba(37, 99, 235, 0.42);
                }
            }
        }

        .section-card {
            background: linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(248, 250, 252, 0.95) 100%);
            border: 1px solid rgba(226, 232, 240, 0.8);
            border-radius: 18px;
            padding: 20px 22px;
            box-shadow: 0 12px 28px rgba(148, 163, 184, 0.15);
            display: flex;
            flex-direction: column;
            gap: 18px;
            transition: transform 0.2s ease, box-shadow 0.2s ease;

            &:hover {
                transform: translateY(-2px);
                box-shadow: 0 18px 36px rgba(148, 163, 184, 0.22);
            }

            &--compact {
                gap: 14px;
                padding: 18px 20px;
            }

            &--status {
                &.is-ativo {
                    border-color: rgba(16, 185, 129, 0.35);

                    .status-icon {
                        background: linear-gradient(135deg, rgba(16, 185, 129, 0.16) 0%, rgba(5, 150, 105, 0.16) 100%);
                        color: #047857;
                    }
                }

                &.is-inativo {
                    border-color: rgba(239, 68, 68, 0.35);

                    .status-icon {
                        background: linear-gradient(135deg, rgba(239, 68, 68, 0.16) 0%, rgba(220, 38, 38, 0.16) 100%);
                        color: #b91c1c;
                    }
                }
            }
        }

        .badge-ativo {
            background: rgba(16, 185, 129, 0.12);
            border: 1px solid rgba(16, 185, 129, 0.35);
            color: #047857;
            font-weight: 600;
            padding: 6px 14px;
            border-radius: 999px;
        }

        .badge-inativo {
            background: rgba(239, 68, 68, 0.12);
            border: 1px solid rgba(239, 68, 68, 0.35);
            color: #b91c1c;
            font-weight: 600;
            padding: 6px 14px;
            border-radius: 999px;
        }

        .section-header {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            flex-wrap: wrap;
            gap: 16px;

            &__info {
                display: flex;
                align-items: flex-start;
                gap: 14px;

                h3 {
                    margin: 0;
                    font-size: 18px;
                    font-weight: 700;
                    color: #1f2937;
                }

                p {
                    margin: 6px 0 0;
                    color: #64748b;
                    font-size: 13px;
                    max-width: 460px;
                    line-height: 1.5;
                }
            }

            &__actions {
                display: flex;
                align-items: center;
                gap: 16px;
                flex-wrap: wrap;
                justify-content: flex-end;

                &--anexo {
                    flex-direction: column;
                    align-items: flex-end;
                    gap: 8px;
                    max-width: 420px;
                }
            }

            &__switches {
                display: flex;
                align-items: center;
                gap: 16px;
                flex-wrap: wrap;
                justify-content: flex-end;
            }
        }

        .anexo-regra {
            margin: 0;
            text-align: right;
            color: #1d4ed8;
            font-size: 13px;
            font-weight: 600;
            line-height: 1.45;
        }

        .section-icon {
            width: 44px;
            height: 44px;
            border-radius: 14px;
            background: linear-gradient(135deg, rgba(59, 130, 246, 0.14) 0%, rgba(16, 185, 129, 0.14) 100%);
            display: flex;
            align-items: center;
            justify-content: center;
            color: #2563eb;
            flex-shrink: 0;
        }

        .section-content {
            display: flex;
            flex-direction: column;
            gap: 18px;
            min-height: 0;
        }

        .runtime-envolvidos-note {
            font-size: 0.88rem;
            color: #64748b;
            line-height: 1.5;
            padding: 12px 14px;
            border-radius: 10px;
            background: rgba(35, 95, 232, 0.06);
            border-left: 3px solid #235FE8;
        }

        .section-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
            gap: 20px;
        }

        .dependency-toolbar {
            background: rgba(248, 250, 252, 0.9);
            border: 1px solid rgba(226, 232, 240, 0.8);
            border-radius: 16px;
            padding: 16px 18px;
            display: flex;
            flex-wrap: wrap;
            gap: 16px;
            align-items: center;
            justify-content: space-between;

            .toolbar-text {
                color: #475569;
                font-size: 13px;
                line-height: 1.5;
                flex: 1 1 320px;
                margin: 0;
            }

            .toolbar-actions {
                display: flex;
                align-items: center;
                gap: 14px;
                flex: 1 1 280px;
                justify-content: flex-end;
            }

            .toolbar-search {
                flex: 1 1 180px;
                max-width: 420px;
                min-width: 180px;
            }
        }

        .modern-input {
            .input-group-text {
                background: rgba(248, 250, 252, 0.9);
                border: 1px solid rgba(203, 213, 225, 0.7);
                border-right: none;
                border-radius: 12px 0 0 12px;
                color: #64748b;
            }

            .form-control {
                border-radius: 0 12px 12px 0;
            }
        }

        .dependency-list {
            display: flex;
            flex-direction: column;
            gap: 12px;
            max-height: 52vh;
            overflow-y: auto;
            padding-right: 4px;
        }

        .user-list-scroll {
            display: flex;
            flex-direction: column;
            gap: 12px;
            max-height: 200px !important;
            min-height: 0;
            overflow-y: auto !important;
            overflow-x: hidden;
            flex-shrink: 0;
            flex-grow: 0;
            box-sizing: border-box;
            padding-right: 4px;
            position: relative;
        }

        .dependency-list.user-list {
            max-height: 280px !important;
            min-height: 120px;
            overflow-y: auto !important;
            overflow-x: hidden;
            flex-shrink: 0;
            flex-grow: 0;
            box-sizing: border-box;
        }

        .section-card .section-content .dependency-list.user-list {
            max-height: 280px !important;
            overflow-y: auto !important;
        }

        .dependency-item {
            border: 1px solid rgba(226, 232, 240, 0.8);
            border-radius: 14px;
            padding: 16px 18px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-wrap: wrap;
            gap: 16px;
            background: rgba(255, 255, 255, 0.88);
            transition: all 0.2s ease;

            &:hover {
                border-color: rgba(59, 130, 246, 0.35);
                box-shadow: 0 12px 24px rgba(37, 99, 235, 0.12);
            }

            &__info {
                display: flex;
                align-items: center;
                gap: 16px;
                flex: 1;
                margin: 0;
                cursor: pointer;
            }

            &__anexo {
                display: flex;
                align-items: center;
                gap: 12px;
                flex-shrink: 0;
            }
        }

        .anexo-ordem {
            display: flex;
            align-items: center;
            gap: 8px;

            &__label {
                margin: 0;
                font-size: 13px;
                font-weight: 600;
                color: #334155;
                white-space: nowrap;
            }

            &__input {
                width: 76px;
                min-height: 36px;
                padding: 4px 8px;
            }
        }

        .dependency-title {
            display: inline-block;
            font-weight: 600;
            color: #0f172a;
            margin: 0;
        }

        .dependency-description {
            color: #64748b;
            font-size: 13px;
        }

        .dep-check {
            width: 1.1rem;
            height: 1.1rem;
            margin-top: 2px;
        }

        .badge-counter {
            background: rgba(59, 130, 246, 0.12);
            border: 1px solid rgba(59, 130, 246, 0.3);
            color: #2563eb;
            font-weight: 600;
            padding: 6px 12px;
            border-radius: 999px;
        }

        .badge-selected {
            background: linear-gradient(135deg, rgba(59, 130, 246, 0.14) 0%, rgba(37, 99, 235, 0.14) 100%);
            color: #1d4ed8;
            border: 1px solid rgba(59, 130, 246, 0.3);
            border-radius: 999px;
            font-size: 12px;
            font-weight: 600;
            padding: 5px 12px;
        }

        .state-message {
            display: flex;
            align-items: center;
            gap: 12px;
            padding: 14px 18px;
            border-radius: 14px;
            font-size: 13px;

            &--loading {
                background: rgba(37, 99, 235, 0.08);
                color: #2563eb;
                border: 1px solid rgba(37, 99, 235, 0.18);
            }

            &--empty {
                background: rgba(248, 250, 252, 0.9);
                color: #475569;
                border: 1px dashed rgba(148, 163, 184, 0.45);

                svg {
                    color: #64748b;
                }
            }
        }

        .empty-state {
            border-radius: 18px;
            border: 1.5px dashed rgba(148, 163, 184, 0.45);
            background: rgba(248, 250, 252, 0.85);
            padding: 36px;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 16px;
            text-align: center;
            color: #475569;

            .empty-icon {
                width: 74px;
                height: 74px;
                border-radius: 22px;
                display: flex;
                align-items: center;
                justify-content: center;
                background: linear-gradient(135deg, rgba(96, 165, 250, 0.18) 0%, rgba(56, 189, 248, 0.18) 100%);
                color: #2563eb;
            }

            h5 {
                margin: 0;
                font-size: 16px;
                font-weight: 700;
                color: #0f172a;
            }

            p {
                margin: 0;
                font-size: 13px;
                max-width: 320px;
                line-height: 1.5;
            }
        }

        .form-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
            gap: 18px;
        }

        .form-group {
            display: flex;
            flex-direction: column;
            gap: 8px;
        }

        .form-label {
            font-weight: 600;
            color: #0f172a;
            font-size: 13px;
            letter-spacing: 0.3px;
            text-transform: uppercase;
        }
        .form-select {
            appearance: none;
            -webkit-appearance: none;
            -moz-appearance: none;
            background-color: #ffffff;
            background-image: url("data:image/svg+xml,%3Csvg width='14' height='9' viewBox='0 0 14 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1.5L7 7.5L13 1.5' stroke='%23838B99' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
            background-repeat: no-repeat;
            background-position: right 16px center;
            background-size: 14px 9px;
            padding-right: 46px;
            cursor: pointer;
        }
        .form-control {
            border-radius: 12px;
            border: 2px solid rgba(148, 163, 184, 0.22);
            background-color: #ffffff;
            padding: 12px 14px;
            font-size: 14px;
            color: #1f2937;
            transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;

            &:focus {
                border-color: rgba(37, 99, 235, 0.45);
                box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.12);
                background-color: #ffffff;
                color: #0f172a;
            }
        }

        .form-check-label {
            color: #1f2937;
            font-weight: 600;
        }

        .form-check-input {
            &:focus {
                border-color: rgba(37, 99, 235, 0.4);
                box-shadow: 0 0 0 0.25rem rgba(37, 99, 235, 0.18);
            }

            &:checked {
                background-color: #2563eb;
                border-color: #2563eb;
            }
        }

        .btn-modern-primary {
            border: none;
            border-radius: 12px;
            padding: 16px 22px;
            font-weight: 700;
            letter-spacing: 0.4px;
            text-transform: uppercase;
            background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
            box-shadow: 0 14px 32px rgba(37, 99, 235, 0.35);
            color: #ffffff !important;
            transition: transform 0.2s ease, box-shadow 0.2s ease;

            &:hover {
                transform: translateY(-2px);
                box-shadow: 0 18px 40px rgba(37, 99, 235, 0.45);
                color: #ffffff !important;
            }

            &:active {
                transform: translateY(0);
            }
        }

        .dependency-list::-webkit-scrollbar {
            width: 8px;
        }

        .dependency-list::-webkit-scrollbar-track {
            background: #f1f5f9;
            border-radius: 8px;
        }

        .dependency-list::-webkit-scrollbar-thumb {
            background: linear-gradient(135deg, #1f7bff 0%, #00b894 100%);
            border-radius: 8px;
        }

        .user-list-scroll {
            &::-webkit-scrollbar {
                width: 6px;
            }

            &::-webkit-scrollbar-track {
                background: rgba(241, 245, 249, 0.6);
                border-radius: 6px;
            }

            &::-webkit-scrollbar-thumb {
                background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
                border-radius: 6px;

                &:hover {
                    background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
                }
            }
        }

        .dependency-list.user-list {
            &::-webkit-scrollbar {
                width: 6px;
            }

            &::-webkit-scrollbar-track {
                background: rgba(241, 245, 249, 0.6);
                border-radius: 6px;
            }

            &::-webkit-scrollbar-thumb {
                background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
                border-radius: 6px;

                &:hover {
                    background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
                }
            }
        }

        .spinner-border {
            color: #2563eb;
        }

        .btn-md {
            z-index: 1001;
        }
    }

    [data-bs-theme="dark"] .modern-modal {
        .modal-modern-content {
            background: linear-gradient(135deg, #0f172a 0%, #111827 100%) !important;
            box-shadow: 0 24px 64px rgba(0, 0, 0, 0.55);
            border: 1px solid rgba(71, 85, 105, 0.45);
        }

        .modal-modern-header {
            .header-icon {
                background: linear-gradient(135deg, rgba(37, 99, 235, 0.28) 0%, rgba(14, 165, 233, 0.28) 100%);
                color: #60a5fa;
            }

            .header-text {
                h2 {
                    color: #f8fafc;
                }

                p {
                    color: #cbd5f5;
                }
            }

            .header-status {
                .badge-artefato {
                    background: linear-gradient(135deg, rgba(99, 102, 241, 0.22) 0%, rgba(14, 165, 233, 0.22) 100%);
                    border-color: rgba(99, 102, 241, 0.4);
                    color: #c7d2fe;
                }
            }
        }

        .modal-modern-body {
            color: #e2e8f0;
        }

        .section-card {
            background: linear-gradient(135deg, rgba(15, 23, 42, 0.92) 0%, rgba(30, 41, 59, 0.94) 100%);
            border: 1px solid rgba(71, 85, 105, 0.55);
            box-shadow: 0 18px 40px rgba(0, 0, 0, 0.45);

            &:hover {
                box-shadow: 0 22px 44px rgba(0, 0, 0, 0.55);
            }
        }

        .section-header__info {
            h3 {
                color: #f8fafc;
            }

            p {
                color: #94a3b8;
            }
        }

        .section-card--status {
            &.is-ativo {
                border-color: rgba(16, 185, 129, 0.45);

                .status-icon {
                    background: linear-gradient(135deg, rgba(16, 185, 129, 0.28) 0%, rgba(5, 150, 105, 0.28) 100%);
                    color: #6ee7b7;
                }
            }

            &.is-inativo {
                border-color: rgba(239, 68, 68, 0.45);

                .status-icon {
                    background: linear-gradient(135deg, rgba(239, 68, 68, 0.28) 0%, rgba(220, 38, 38, 0.28) 100%);
                    color: #fca5a5;
                }
            }
        }

        .badge-ativo {
            background: rgba(16, 185, 129, 0.2);
            border-color: rgba(16, 185, 129, 0.45);
            color: #6ee7b7;
        }

        .badge-inativo {
            background: rgba(239, 68, 68, 0.2);
            border-color: rgba(239, 68, 68, 0.45);
            color: #fca5a5;
        }

        .section-icon {
            background: linear-gradient(135deg, rgba(37, 99, 235, 0.32) 0%, rgba(5, 150, 105, 0.26) 100%);
            color: #93c5fd;
        }

        .dependency-toolbar {
            background: rgba(15, 23, 42, 0.86);
            border-color: rgba(71, 85, 105, 0.6);

            .toolbar-text {
                color: #cbd5f5;
            }
        }

        .anexo-regra {
            color: #93c5fd;
        }

        .modern-input {
            .input-group-text {
                background: rgba(15, 23, 42, 0.82);
                border-color: rgba(71, 85, 105, 0.6);
                color: #94a3b8;
            }

            .form-control {
                background: rgba(15, 23, 42, 0.82);
                border-color: rgba(71, 85, 105, 0.6);
                color: #e2e8f0;
            }
        }

        .dependency-item {
            background: rgba(15, 23, 42, 0.9);
            border-color: rgba(71, 85, 105, 0.6);

            &:hover {
                border-color: rgba(59, 130, 246, 0.6);
                box-shadow: 0 16px 32px rgba(37, 99, 235, 0.35);
            }
        }

        .dependency-title {
            color: #e2e8f0;
        }

        .dependency-description {
            color: #94a3b8;
        }

        .anexo-ordem__label {
            color: #e2e8f0;
        }

        .badge-counter {
            background: rgba(59, 130, 246, 0.18);
            border-color: rgba(59, 130, 246, 0.35);
            color: #bfdbfe;
        }

        .badge-selected {
            background: linear-gradient(135deg, rgba(59, 130, 246, 0.24) 0%, rgba(37, 99, 235, 0.24) 100%);
            color: #bfdbfe;
            border-color: rgba(59, 130, 246, 0.4);
        }

        .state-message {
            &--loading {
                background: rgba(37, 99, 235, 0.22);
                border-color: rgba(37, 99, 235, 0.35);
                color: #bfdbfe;
            }

            &--empty {
                background: rgba(15, 23, 42, 0.82);
                border-color: rgba(71, 85, 105, 0.6);
                color: #cbd5f5;

                svg {
                    color: #94a3b8;
                }
            }
        }

        .empty-state {
            background: rgba(15, 23, 42, 0.76);
            border-color: rgba(71, 85, 105, 0.5);
            color: #94a3b8;

            .empty-icon {
                background: linear-gradient(135deg, rgba(59, 130, 246, 0.26) 0%, rgba(56, 189, 248, 0.26) 100%);
                color: #38bdf8;
            }

            h5 {
                color: #e2e8f0;
            }
        }

        .form-label {
            color: #e2e8f0;
        }

        .form-control,
        .form-select {
            background-color: rgba(15, 23, 42, 0.85);
            border-color: rgba(71, 85, 105, 0.6);
            color: #e2e8f0;

            &:focus {
                background-color: rgba(15, 23, 42, 0.95);
                color: #f8fafc;
            }
        }

        .form-select,
        .form-select:focus {
            background-color: rgba(15, 23, 42, 0.85);
            background-image: url("data:image/svg+xml,%3Csvg width='14' height='9' viewBox='0 0 14 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1.5L7 7.5L13 1.5' stroke='%2394A3B8' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
            background-repeat: no-repeat;
            background-position: right 16px center;
            background-size: 14px 9px;
        }

            .form-select:focus {
                background-color: rgba(15, 23, 42, 0.95);
            }

        .form-select option {
            background: #1f2937;
            color: #e2e8f0;
        }

        .form-check-label {
            color: #e2e8f0;
        }

        .form-check-input {
            background-color: rgba(15, 23, 42, 0.9);
            border-color: rgba(71, 85, 105, 0.6);

            &:checked {
                background-color: #3b82f6;
                border-color: #3b82f6;
            }
        }

        .btn-modern-primary {
            background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
            box-shadow: 0 16px 36px rgba(37, 99, 235, 0.45);
        }

        .dependency-list::-webkit-scrollbar-thumb {
            background: linear-gradient(135deg, #2563eb 0%, #059669 100%);
        }

        .user-list-scroll {
            &::-webkit-scrollbar-track {
                background: rgba(15, 23, 42, 0.6);
            }

            &::-webkit-scrollbar-thumb {
                background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);

                &:hover {
                    background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
                }
            }
        }

        .user-list-scroll {
            &::-webkit-scrollbar-track {
                background: rgba(15, 23, 42, 0.6);
            }

            &::-webkit-scrollbar-thumb {
                background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);

                &:hover {
                    background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
                }
            }
        }

        .dependency-list.user-list {
            &::-webkit-scrollbar-track {
                background: rgba(15, 23, 42, 0.6);
            }

            &::-webkit-scrollbar-thumb {
                background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);

                &:hover {
                    background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
                }
            }
        }

        .spinner-border {
            color: #3b82f6;
        }

        .btn-pill {
            background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
            border: 1px solid rgba(71, 85, 105, 0.6);
            color: #e2e8f0;

            &:hover {
                background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
                border-color: transparent;
                box-shadow: 0 14px 32px rgba(239, 68, 68, 0.45);
            }
        }
    }

    @media (max-width: 768px) {
        :deep(.modern-modal) {
            .modal-modern-header,
            .modal-modern-body,
            .modal-modern-footer {
                padding: 24px 20px;
            }

            .modal-modern-header {
                flex-direction: column;
                align-items: stretch;

                &::after {
                    left: 20px;
                    right: 20px;
                }

                .header-icon {
                    width: 58px;
                    height: 58px;
                }
            }

            .section-card {
                padding: 18px;
            }

            .artefato-cliente-alert {
                flex-direction: column;

                &__editor {
                    width: 100%;
                }

                &__acao {
                    align-self: stretch;
                }
            }

            .section-grid {
                grid-template-columns: 1fr;
            }
        }
    }

    @media (max-width: 576px) {
        :deep(.modern-modal) {
            .modal-dialog {
                margin: 12px;
            }

            .modal-modern-header .header-text h2 {
                font-size: 22px;
            }

            .section-header__info {
                flex-direction: column;
            }
        }
    }
</style>
